var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVgood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 279.88,
    height: 279.881,
    viewBox: "0 0 279.88 279.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1746",
    d: "M0-682.665H279.88v279.881H0Z",
    transform: "translate(0 682.665)",
    fill: "#3d3c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1740",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1742",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1744",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1750",
    transform: "translate(8.2 41.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1752",
    d: "M-331.2-165.2c0,63.4-51.4,115.341-114.795,115.341S-561.332-101.805-561.332-165.2-509.39-280-445.991-280A114.8,114.8,0,0,1-331.2-165.2Z",
    transform: "translate(561.332 279.999)",
    fill: "none",
    stroke: "#77406f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1754",
    transform: "translate(57.944 156.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1756",
    d: "M0,0A65.672,65.672,0,0,0,65.6,65.6,65.672,65.672,0,0,0,131.194,0Z",
    fill: "none",
    stroke: "#77406f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1758",
    transform: "translate(201.716 8.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1760",
    d: "M-5.5,0-9.321,23.034",
    transform: "translate(9.321)",
    fill: "none",
    stroke: "#77406f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1762",
    transform: "translate(248.647 74.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1764",
    d: "M-33.149,0-56.183,3.822",
    transform: "translate(56.183)",
    fill: "none",
    stroke: "#77406f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1766",
    transform: "translate(227.855 28.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1768",
    d: "M-33.363,0-56.545,23.183",
    transform: "translate(56.545)",
    fill: "none",
    stroke: "#77406f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1770",
    transform: "translate(66.144 98.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1772",
    d: "M0-23.6A16.4,16.4,0,0,1,16.4-40,16.4,16.4,0,0,1,32.8-23.6",
    transform: "translate(0 40)",
    fill: "none",
    stroke: "#77406f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1774",
    transform: "translate(148.14 98.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1776",
    d: "M0-23.6A16.4,16.4,0,0,1,16.4-40,16.4,16.4,0,0,1,32.8-23.6",
    transform: "translate(0 40)",
    fill: "none",
    stroke: "#77406f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1778",
    transform: "translate(84.196 189.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1780",
    d: "M-113.246-28.289a49.123,49.123,0,0,0-39.346-19.657,49.123,49.123,0,0,0-39.345,19.657",
    transform: "translate(191.937 47.947)",
    fill: "none",
    stroke: "#77406f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVgood);
export default __webpack_public_path__ + "static/media/vgood.9e19a77471c3a2c6b031dbfb59dcf0af.svg";
export { ForwardRef as ReactComponent };